import React from 'react'
import './style.scss'
import MarkdownIt from 'markdown-it'
const md = new MarkdownIt()

import ArrowCta from '../arrow-cta'
import Button from '../buttons'

const PrimaryHorizontalCard = ({company, nextCompanyName, index}) => {
  const companyName = company.nameOfCompany
  const sectionID = companyName.split(' ').join('-').toLowerCase()
  const backgroundImage = company.backgroundImage.file.url
  const companyDescription = md.renderInline(company.companyDescription.companyDescription)
  const companyLogo = company.companyLogo.file.url
  const companyLogoName = company.companyLogo.file.fileName
  let nextCompanyLink
  if (nextCompanyName) {
    nextCompanyLink = nextCompanyName.split(' ').join('-').toLowerCase()
  }
  let wrapperClasses = 'primaryHorizontal-wrapper-' + index
  if (index === 0) {
    wrapperClasses = 'primaryHorizontal-wrapper-first primaryHorizontal-wrapper-slash'
  }
  return (
    <div className={`primaryHorizontal-wrapper ${wrapperClasses}`} style={{backgroundImage: 'url(' + backgroundImage + ')'}} id={`${sectionID}-card`}>
      <div className='container'>
        <div className='primaryHorizontal-innerWrapper'>
          <div className='primaryHorizontal-mainContentWrapper'>
            <div className='combo combo--rev combo--stack--portable'>
              <div className='combo-first u-verticalAlignMiddle'>
                <img className='primaryHorizontal-logo' src={companyLogo} alt={companyLogoName} />
              </div>
              <div className='combo-last'>
                <div className='primaryHorizontal-sideContentWrapper'>
                  <h4 className='primaryHorizontal-description' dangerouslySetInnerHTML={{__html: companyDescription}} />
                  <Button text='Our Companies' link='/companies' secondary />
                </div>
              </div>
            </div>
          </div>
          <div className='primaryHorizontal-separator'>
            <hr className='u-marginBottomSmall' />
            <ArrowCta text={nextCompanyName ? `What we’re doing for ${nextCompanyName}.` : 'About B37'} link={nextCompanyName ? `#${nextCompanyLink}-card` : '#footer'} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default PrimaryHorizontalCard



// WEBPACK FOOTER //
// ./src/components/primary-horizontal-card/index.js